var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { goBack, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { loadPendingUnstaking } from '@popup/steem/actions/token.actions';
import TokensUtils from '@popup/steem/utils/tokens.utils';
import { Screen } from '@reference-data/screen.enum';
import { KeychainKeyTypes } from '@steempro/steem-keychain-commons';
import Decimal from 'decimal.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import FormatUtils from 'src/utils/format.utils';
const TokenPendingUnstake = ({ tokenInfo, pendingUnstaking, activeAccount, setTitleContainerProperties, loadPendingUnstaking, navigateToWithParams, goBack, setErrorMessage, setSuccessMessage, removeFromLoadingList, addToLoadingList, }) => {
    const [totalUnstaking, setTotalUnstaking] = useState(0);
    const [tokenUnstaking, setTokenUnstaking] = useState();
    useEffect(() => {
        setTitleContainerProperties({
            title: 'html_popup_pending_unstake',
            titleParams: [tokenInfo.symbol],
            isBackButtonEnabled: true,
        });
        const tokenUnstaking = pendingUnstaking.filter((e) => e.symbol === tokenInfo.symbol);
        const sumUnstaking = tokenUnstaking.reduce((a, b) => Decimal.add(parseFloat(b.quantityLeft), a).toNumber(), 0);
        setTotalUnstaking(sumUnstaking);
        setTokenUnstaking(tokenUnstaking);
    }, []);
    const cancelUnstake = (pendingUnstake) => {
        const fields = [
            {
                label: 'popup_html_amount',
                value: `${FormatUtils.formatCurrencyValue(pendingUnstake.quantityLeft)} ${pendingUnstake.symbol}`,
            },
        ];
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage('html_popup_cancel_unstaking_message'),
            title: 'html_popup_pending_unstake',
            titleParams: [tokenInfo.symbol],
            fields: fields,
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                let success;
                try {
                    addToLoadingList('html_popup_canceling_unstake_token');
                    success = yield TokensUtils.cancelUnstakeToken(pendingUnstake.txID, activeAccount, options);
                    if (success) {
                        setTimeout(() => {
                            loadPendingUnstaking(activeAccount.name);
                            goBack();
                        }, 3000);
                        setSuccessMessage('html_popup_cancel_unstake_token_success');
                    }
                    else {
                        setErrorMessage('html_popup_cancel_unstake_token_fail');
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList('html_popup_canceling_unstake_token');
                }
            }),
        });
    };
    return (React.createElement("div", { className: "pending-unstake-token-page" }, (tokenUnstaking === null || tokenUnstaking === void 0 ? void 0 : tokenUnstaking.length) && totalUnstaking && totalUnstaking > 0 && (React.createElement("div", { className: "panel" },
        React.createElement("div", { className: "total" },
            React.createElement("div", { className: "label" }, getMessage('html_popup_total_pending_unstake')),
            React.createElement("div", { className: "value" },
                FormatUtils.formatCurrencyValue(totalUnstaking, tokenInfo.precision),
                ' ',
                tokenInfo.symbol)),
        React.createElement("div", { className: "list" }, tokenUnstaking.map((unstaking, index) => (React.createElement("div", { className: "unstaking-row", key: `unstaking-${index}` },
            React.createElement("div", { className: "left" },
                React.createElement("div", { className: "top" }, getMessage('html_popup_remaining_transaction', [unstaking.numberTransactionsLeft.toString()])),
                React.createElement("div", { className: "middle" },
                    React.createElement(SVGIcon, { icon: SVGIcons.WALLET_TOKEN_PENDING_UNSTAKE_NEXT_TX, tooltipMessage: 'html_popup_next_unstake_transaction' }),
                    React.createElement("span", null, moment(unstaking.nextTransactionTimestamp).format('YYYY-MM-DD hh:mm:ss'))),
                React.createElement("div", { className: "bottom" },
                    React.createElement(SVGIcon, { className: "next-tx-amount", icon: SVGIcons.WALLET_TOKEN_PENDING_UNSTAKE_NEXT_TX_AMOUNT, tooltipMessage: 'html_popup_next_unstake_transaction' }),
                    React.createElement("span", null, getMessage('html_popup_unstake_per_transaction', [
                        FormatUtils.formatCurrencyValue(Decimal.div(unstaking.quantity, tokenInfo.numberTransactions).toNumber()),
                        unstaking.symbol,
                    ])))),
            React.createElement("span", { className: "right" },
                `${FormatUtils.nFormatter(Number(unstaking.quantityLeft), 3)}`,
                ' ',
                "/",
                ' ',
                `${FormatUtils.nFormatter(Number(unstaking.quantity), 3)} ${unstaking.symbol}`),
            React.createElement(SVGIcon, { className: "cancel-unstake", icon: SVGIcons.GLOBAL_DELETE, onClick: () => {
                    cancelUnstake(unstaking);
                } })))))))));
};
const mapStateToProps = (state) => {
    return {
        pendingUnstaking: state.steem.tokensPendingUnstaking,
        tokenInfo: state.navigation.stack[0].params.tokenInfo,
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {
    setTitleContainerProperties,
    navigateToWithParams,
    goBack,
    loadPendingUnstaking,
    removeFromLoadingList,
    addToLoadingList,
    setErrorMessage,
    setSuccessMessage,
});
export const TokenPendingUnstakePage = connector(TokenPendingUnstake);
